<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div style="margin-bottom: 10px">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="18" :sm="12">
            <a-button @click="handleBack" icon="left" style="margin-right: 10px">返回</a-button>
            研究中心：
            <a-select placeholder="请选择研究中心" v-model="queryParam.centerId" style="width: 200px" @change="conditionChange" >
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
                {{ item.center.name }}
              </a-select-option>
            </a-select>
            <label style="margin-left: 20px">周期：</label>
            <a-select v-model='queryParam.periodItemId' placeholder='请选择周期' style="width: 200px" @change="conditionChange" >
              <a-select-option :value='item.id' :key="item.id" v-for="item in periodItemList">{{item.name}}</a-select-option>
            </a-select>
          </a-col>

          <!--<a-col :md="6" :sm="8">-->
          <!--<span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
          <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
          <!--<a-button type="" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
          <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
          <!--{{ toggleSearchStatus ? '收起' : '展开' }}-->
          <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
          <!--</a>-->
          <!--</span>-->
          <!--</a-col>-->

        </a-row>
      </a-form>
    </div>


    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :scroll="{x:'100%'}"
        :columns="columns"
        :dataSource="dataSource"
        @change="handleFilterChange"
        :pagination="ipagination"
        :loading="loading">
        <template >
          ,
        </template>
        <span slot="status" slot-scope="text, record, index">
          <template v-if="text">
            <template v-for="(tItem,index) in text.split(',')">
              <a-tag v-if="index === 0" :color="textInfo[tItem].color" style="cursor: pointer">{{ textInfo[tItem].text }}</a-tag>
              <a-tag v-if="index === 1 && tItem==='1'" color="red" style="cursor: pointer">过期提交</a-tag>
            </template>
          </template>
          <label v-else></label>
        </span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import {formStatus} from '@/constants/patient'
  import Vue from 'vue'
  export default {
    name: "Item",
    mixins: [JeecgListMixin],
    components: {

    },
    props:['centerId','periodItemId'],
    data() {
      return {
        textInfo:formStatus,
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {centerId:'',periodItemId:''},
        centerList:[],
        periodItemList:[],
        columns: [],
        url: {
          list: "/project/statistic/visitRate/submitFormInfoItem",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.init()
    },
    watch:{
      centerId(){
        this.init()
      }
    },
    methods: {
      moment,
      init(){
        this.queryParam.centerId = this.centerId
        this.queryParam.periodItemId = this.periodItemId
        this.queryParam.projectId = this.projectId
        this.loadCenter()
        this.loadPeriodItem()
        this.loadData()
      },
      viewItem(row){
        // console.log(row)
        this.$router.push({path:'/project/patient/registerview/'+row.id})
      },
      loadPeriodItem(){
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0',base:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
      },
      conditionChange(){
        this.queryParam.filters=""
        this.loadData()
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error("请设置url.list属性!")
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.data;
            if(res.result.page != null && res.result.page !== undefined){
              this.ipagination.total = res.result.page.total;
            }
            const columns = [
              {
                title: '受试者编号',
                align: "center",
                fixed:'left',
                dataIndex: 'patientnum',
                width: 100,
              },
              {
                title: '受试者姓名',
                align: "center",
                fixed:'left',
                dataIndex: 'name',
                width: 100,
              },
              {
                title: '性别',
                align: "center",
                dataIndex: 'sex',
                width: 100,
                customRender: function (text) {
                  if (text === '1') {
                    return '男'
                  } else if (text === '0') {
                    return '女'
                  } else {
                    return text
                  }
                }
              },
              {
                title: '年龄',
                align: "center",
                dataIndex: 'age',
                width: 100,
              },
              {
                title: '通过筛选日期',
                align: "center",
                dataIndex: 'passdate',
                width: 150,
              },
              {
                title: '基点日期',
                align: "center",
                dataIndex: 'basedate',
                width: 100,
              },
              {
                title: '开始日期',
                align: "center",
                dataIndex: 'startdate',
                width: 100,
              },
              {
                title: '结束日期',
                align: "center",
                dataIndex: 'enddate',
                width: 100,
              }
            ]
            const columnMap = res.result.columnInfo
            const parent = {
              title: '',
              align: "center",
              children:[],
            }
            for (let key in columnMap){
              if(key==='periodname'){
                parent.title = columnMap[key]
              }
              else{
                parent.children.push({
                  title: columnMap[key],
                  align: "center",
                  dataIndex: key,
                  width: 200,
                  scopedSlots: { customRender: 'status' },
                  filters: [
                    { text: '已提交(完整)', value: '4' },
                    { text: '已提交(数据缺失)', value: '3' },
                    { text: '已提交(失访)', value: '5' },
                    { text: '暂存', value: '2' },
                    { text: '未开始', value: '1' },
                  ],
                })
              }
            }
            columns.push(parent)
            columns.push({
              title: '操作',
              align: "center",
              fixed:'right',
              dataIndex: 'action',
              width: 120,
              customRender: (value, row, index) => {
                const child = this.$createElement('a', {
                  domProps: {
                    innerHTML: '查看明细'
                  },
                  on: {
                    click: ()=> {
                      this.viewItem(row)
                    }
                  }
                })
                const obj = {
                  children: child,
                  attrs: {},
                };
                return obj;
              },
            })
            this.columns = columns
            if(this.loadDataCallback){
              this.loadDataCallback()
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      handleBack(){
        this.$emit('typeChange','1')
      },
      dateChange(){
        if(this.registerDateRange.length===0){
          this.queryParam.startDate = ''
          this.queryParam.endDate = ''
        }else {
          this.queryParam.startDate = this.registerDateRange[0]
          this.queryParam.endDate = this.registerDateRange[1]
        }
        this.loadData()
      },
      loadCenter(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }
        })
      },
      handleFilterChange(pagination, filters, sorter){
        this.ipagination = pagination;
        console.log('Filters:', filters);        
        this.queryParam.filters = JSON.stringify(filters)
        this.loadData()
      },
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
